<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="purchase-order-details" style="display: flex; flex-direction: column;overflow-x: hidden;width: 100%;">

      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">

          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content #pdfContent class="ship-fscoll hgt ship-pr-sec">
                  <div class="purchase-order-details-title">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin: 10px 0;">
                                <!-- Purchase Order Info -->
                                <div id="purchaseOrderDetails" style="font-size: 22px; font-weight: 800;">
                                    Service Purchase Order: {{this.headerFormGroup.get('purchaseOrderRefNumber')?.value}}
                                </div>

                                <!-- Action Buttons -->
                                <div style="display: flex; gap: 10px;">
                                    <button mat-stroked-button color="primary" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;color:#42A190;background-color: #D9E0E4;" 
                                    [matMenuTriggerFor]="downloadMenu">
                                    Download PO <mat-icon style="color:#42A190;">download</mat-icon>
                                    </button>

                                    <mat-menu #downloadMenu="matMenu">
                                      <button
                                        mat-menu-item
                                        (click)="generatePoExcel()"
                                      >
                                        <mat-icon>download</mat-icon>
                                        <span>Download as Excel</span>
                                      </button>
                                      <button
                                        mat-menu-item
                                        (click)="downloadPO()"
                                      >
                                        <mat-icon>download</mat-icon>
                                        <span>Download as PDF</span>
                                      </button>
                                    </mat-menu>

                                    <span
                                    [matTooltip]="userkycStatus !== 'APPROVED' ? 'Reject action is disabled until KYC is approved.' : ''"
                                    matTooltipPosition="above">
                                      <button mat-raised-button color="warn" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7"  class="reject-btn" (click)="rejectPO()"
                                      [disabled]="userkycStatus !== 'APPROVED'">
                                        Reject
                                      </button>
                                    </span>
                                   
                                    <span
                                    [matTooltip]="userkycStatus !== 'APPROVED' ? 'Accept action is disabled until KYC is approved.' : ''"
                                    matTooltipPosition="above">
                                    <button mat-raised-button color="primary" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" class="accept-btn" (click)="acceptPO()"
                                    [disabled]="userkycStatus !== 'APPROVED'">
                                      Accept
                                    </button>
                                    </span>
                                   

                                    <button mat-raised-button color="primary" *ngIf="headerResponse?.purchaseOrderStatus === 6 && userkycStatus == 'APPROVED'" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #42A190;" (click)="createInvoice()">
                                      Create Invoice <mat-icon>receipt_long</mat-icon>
                                    </button>

                                    <button mat-button color="primary" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #E6E6E6;" (click)="close()">
                                    Close <mat-icon>navigate_next</mat-icon>
                                    </button>
                                </div>
                            </div>

                    </div>
                  <div style="width:100%;">

                      <div>
                          <div style="display: flex;justify-content: space-between;align-items: center;margin-top:30px">
                            <div>
                              <form [formGroup]="costSummaryFormGroup">
                                <div style="display: flex; flex-direction: column; width: 250px;">
                                    <label>Quote Currency</label>
                                    <input matInput
                                      style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; color: #333; cursor: not-allowed;"
                                      [value]="(costSummaryFormGroup.get('currency')?.value?.currencyCode || '') + (costSummaryFormGroup.get('currency')?.value?.currencyName ? ' - ' + costSummaryFormGroup.get('currency')?.value?.currencyName : '')"
                                      readonly />
                                </div>

                              </form>
                            </div>

                          </div>
                          <div style="display: flex; flex-direction: column; overflow-x: auto; width: 100%;margin-top:70px">

                              <form [formGroup]="lineItemTableForm">

                                <ngx-datatable
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'force'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  >

                                  <ngx-datatable-column name="S.No." [width]="80">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'position')" readonly style="width: 40px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Name">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'serviceName')" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'serviceDescription')"
                                        readonly [rows]="1"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Scope of Work">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'scopeOfWork')"
                                        readonly [rows]="1"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'supplierComment')"
                                        readonly [rows]="1"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'uom')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'supplierUom')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'quantity')" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'supplierQuantity')" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Unit Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{ getRowControl(rowIndex, 'unitCost').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{ getRowControl(rowIndex, 'discount').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Total Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{ getRowControl(rowIndex, 'totalCost').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'leadTime')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                </ngx-datatable>
                              </form>

                          </div>

                          <!-- Cost Summary -->
                          <div style="margin: 30px 0px; float: none">
                            <form [formGroup]="costSummaryFormGroup">
                              <div class="cost-summary-container">
                                <!-- First Table -->
                                <table class="summary-table">
                                  <tbody>
                                    <tr>
                                      <td><b>Total <span *ngIf="costSummaryFormGroup.get('currency')?.value?.currencyCode">
                                        ({{ costSummaryFormGroup.get('currency')?.value?.currencyCode }})
                                        </span></b></td>
                                      <td>
                                        {{ (costSummaryFormGroup.get('lineItemTotal')?.value || 0.0) | number: '1.3-3' }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Line Item list Price Sub Total</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="lineItemListPriceSubtotal"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Line Item Discount</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="lineItemDiscount"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <!-- Second Table -->
                                <table class="summary-table">
                                  <tbody>
                                    <tr>
                                      <td>Line Item Sub Total</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="lineItemSubtotal"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>General Discount</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="generalDiscountValue"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td (click)="toggleFreightDetails()">
                                        Air Freight (In amount)<mat-icon>{{
                                          showFreightDetails
                                            ? 'expand_less'
                                            : 'expand_more'
                                        }}</mat-icon>
                                      </td>
                                      <td>
                                        <input type="hidden" formControlName="lineItemFreightTotal" />
                                        <input
                                          type="text"
                                          matInput
                                          [value]="(costSummaryFormGroup.get('lineItemFreightTotal')?.value || 0) | number: '1.3-3'"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <!-- Freight details table -->
                                <div
                                  *ngIf="showFreightDetails && costSummaryFormGroup.get('quoteLineItemFreight')?.value"
                                  style="display: flex; flex-direction: column"
                                >
                                  <table class="summary-table">
                                    <thead>
                                      <tr>
                                        <th style="padding: 10px">Description</th>
                                        <th style="padding: 10px">Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="let item of costSummaryFormGroup.get('quoteLineItemFreight')?.value"
                                      >
                                        <td>{{ item.freightDescription }}</td>
                                        <td>{{ item.freightValue | number: '1.3-3' }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <!-- Tax Table -->
                                <table class="summary-table">
                                  <tbody>
                                    <tr>
                                      <td>Applicable Tax Profile</td>
                                      <td>
                                        {{ costSummaryFormGroup.get('lineItemApplicableTaxProfile')?.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Tax Amount</td>
                                      <td>
                                        {{ (costSummaryFormGroup.get('lineItemTaxAmount')?.value || 0) | number: '1.3-3' }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                              </div>
                            </form>
                          </div>

                      </div>

                  </div>

                  <!-- Header Details Section -->
                  <div style="width:100%;">

                    <form [formGroup]="headerFormGroup">
                    <div>

                        <!-- Purchase Order Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form1')">
                            Purchase Order Details
                            <mat-icon>{{ isForm1Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm1Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Purchase Order Number</mat-label>
                                <input matInput formControlName="purchaseOrderRefNumber" readonly>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Purchase Order Date</mat-label>
                                <input matInput [matDatepicker]="poDate" formControlName="purchaseOrderDate" readonly>
                                <mat-datepicker-toggle matSuffix [for]="poDate"></mat-datepicker-toggle>
                                <mat-datepicker #poDate></mat-datepicker>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>RFQ Ref Number</mat-label>
                                <input matInput formControlName="rfqRefNumber" readonly>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>RFQ Date</mat-label>
                                <input matInput [matDatepicker]="rfqDate" formControlName="rfqDate" readonly>
                                <mat-datepicker-toggle matSuffix [for]="rfqDate"></mat-datepicker-toggle>
                                <mat-datepicker #rfqDate></mat-datepicker>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Quote Ref Number</mat-label>
                                <input matInput formControlName="quoteRefNumber" readonly>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Quotation Date</mat-label>
                                <input matInput [matDatepicker]="quotationDate" formControlName="quotationDate" readonly>
                                <mat-datepicker-toggle matSuffix [for]="quotationDate"></mat-datepicker-toggle>
                                <mat-datepicker #quotationDate></mat-datepicker>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Expected Delivery Date</mat-label>
                                <input matInput [matDatepicker]="expectedDeliveryDate" formControlName="expectedDeliveryDate" readonly>
                                <mat-datepicker-toggle matSuffix [for]="expectedDeliveryDate"></mat-datepicker-toggle>
                                <mat-datepicker #expectedDeliveryDate></mat-datepicker>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Buyer Company Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form2')">
                            Buyer Company Details
                            <mat-icon>{{ isForm2Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm2Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyer Name</mat-label>
                                <input matInput formControlName="buyerCompanyName" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Email Id</mat-label>
                                <input matInput formControlName="buyerEmail" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="buyerPhone" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="buyerFax" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="buyerAddress" readonly>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Buyer Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form3')">
                            Buyer Details
                            <mat-icon>{{ isForm3Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm3Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Contact Person (Job Title)</mat-label>
                                <input matInput formControlName="buyerContactPerson" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Email Id</mat-label>
                                <input matInput formControlName="buyerContactEmail" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="buyerContactPhone" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="buyerContactFax" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="buyerContactAddress" readonly>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Supplier Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form4')">
                            Supplier Details
                            <mat-icon>{{ isForm4Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm4Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Supplier Contact Name</mat-label>
                                <input matInput formControlName="supplierContactName" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Email Id</mat-label>
                                <input matInput formControlName="supplierEmail" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="supplierPhone" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="supplierFax" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Company Email</mat-label>
                                <input matInput formControlName="supplierCompanyEmail" readonly>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Vessel Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form5')">
                            Vessel Details
                            <mat-icon>{{ isForm5Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm5Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Vessel Name</mat-label>
                                <input matInput formControlName="vesselName" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Vessel IMO Number</mat-label>
                                <input matInput formControlName="vesselIMONumber" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Vessel Type</mat-label>
                                <input matInput formControlName="vesselType" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Class</mat-label>
                                <input matInput formControlName="vesselClass" readonly>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Port Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form6')">
                            Port Details
                            <mat-icon>{{ isForm6Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm6Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Port Name</mat-label>
                                <input matInput formControlName="portName" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Port Code</mat-label>
                                <input matInput formControlName="portCode" readonly>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Vessel ETA</mat-label>
                                <input matInput [matDatepicker]="vesselETA" formControlName="vesselETA" readonly>
                                <mat-datepicker-toggle matSuffix [for]="vesselETA"></mat-datepicker-toggle>
                                <mat-datepicker #vesselETA></mat-datepicker>
                            </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Vessel ETD</mat-label>
                                <input matInput [matDatepicker]="vesselETD" formControlName="vesselETD" readonly>
                                <mat-datepicker-toggle matSuffix [for]="vesselETD"></mat-datepicker-toggle>
                                <mat-datepicker #vesselETD></mat-datepicker>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                    </div>
                    </form>

                  </div>

                  <!-- Payment Terms Section -->
                  <div style="width:100%;">
                    <form [formGroup]="paymentFormGroup">
                        <!-- Buyer Payment Terms -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form7')">
                            Buyer Payment Terms
                            <mat-icon>{{ isForm7Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm7Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Billing Address</mat-label>
                                <input matInput formControlName="billingAddress" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Applicable Tax Profile</mat-label>
                                <input matInput formControlName="applicableTaxProfile" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyers Payment Terms</mat-label>
                                <input matInput formControlName="buyersPaymentTerms" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3;flex: 0 0 63.2%;margin-top:20px;">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Conditions</mat-label>
                                <textarea matInput formControlName="buyerTermsAndConditions" readonly></textarea>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Port Agent Details -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form8')">
                            Port Agent Details
                            <mat-icon>{{ isForm8Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm8Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agency Name</mat-label>
                                  <input matInput formControlName="portAgencyName" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Name</mat-label>
                                  <input matInput formControlName="portAgentName" readonly />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Number</mat-label>
                                  <input matInput formControlName="portAgentPhoneNumber" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Contact</mat-label>
                                  <input matInput formControlName="portAgentContact" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Fax</mat-label>
                                  <input matInput formControlName="portAgentPhoneFax" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Email ID</mat-label>
                                  <input matInput formControlName="portAgentEmail" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Address</mat-label>
                                  <input matInput formControlName="portAgentAddress" readonly/>
                              </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Terms and Conditions -->
                        <div class="header-form-header">
                        <span
                            style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                            (click)="toggleVisibility('form9')">
                            Terms and Conditions
                            <mat-icon>{{ isForm9Expand ? 'minimize' : 'add' }}</mat-icon>
                        </span>

                        <div *ngIf="isForm9Expand" class="three-column-flex">
                            <div class="form-item-row-header" style="grid-column: span 3;margin-top:20px">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Condition</mat-label>
                                <textarea matInput formControlName="termsAndConditions" readonly></textarea>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <div class="file-name-box">
                                {{
                                getHeaderAttachmentCount() === 0
                                    ? 'No files chosen'
                                    : getHeaderAttachmentCount() === 1
                                    ? '1 file chosen'
                                    : getHeaderAttachmentCount() + ' files chosen'
                                }}
                                <button
                                    mat-icon-button
                                    *ngIf="getHeaderAttachmentCount() > 0"
                                    (click)="togglePreview(true, 'generalAttachment')"
                                    type="button"
                                >
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </form>
                  </div>

                  <!-- Bottom Accept/Reject Buttons -->
                  <div style="width:100%;display: flex;justify-content: center;align-items: center;margin-top:20px">
                    <span
                      [matTooltip]="userkycStatus !== 'APPROVED' ? 'Reject action is disabled until KYC is approved.' : ''"
                      matTooltipPosition="above">
                      <button mat-raised-button color="warn" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7"  class="reject-btn" (click)="rejectPO()"
                      [disabled]="userkycStatus !== 'APPROVED'">
                        Reject</button>
                    </span>
                    <span
                      [matTooltip]="userkycStatus !== 'APPROVED' ? 'Accept action is disabled until KYC is approved.' : ''"
                      matTooltipPosition="above">
                      <button mat-raised-button color="primary" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" class="accept-btn" (click)="acceptPO()"
                      [disabled]="userkycStatus !== 'APPROVED'">
                        Accept</button>
                    </span>
                   

                      <button
                      mat-icon-button
                      matSuffix
                      matTooltipClass="mat-tooltip-custom"
                      matTooltipPosition="left"
                      [matTooltip]="reviewTooltip">
                      <mat-icon>info_outline</mat-icon>
                    </button>
                  </div>

              </mat-card-content>
          </mat-card>
      </div>
  </div>
</div>


<!-- Attachment Carousel -->
<div
  class="blur"
  *ngIf="previewSection"
  (click)="togglePreview(false, '')"
></div>

<div class="carousel-container" *ngIf="previewSection">
  <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <ng-container *ngIf="previewDoc[currentIndex]">
        <div
          class="carousel-preview-inner"
          *ngIf="isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <pdf-viewer
            [src]="previewDoc[currentIndex].dataUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="pdf-content"
          ></pdf-viewer>
        </div>

        <div
          class="carousel-preview-inner"
          *ngIf="!isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <img
            [src]="previewDoc[currentIndex]?.dataUrl"
            alt="attachment image"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>


<!-- Accept Order Modal -->
<div
  class="blur"
  *ngIf="showAcceptOrder"
  (click)="cancel()"
></div>

<div class="namemodal" *ngIf="showAcceptOrder" style="width: 27%; padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <!-- Title -->
    <h2 style="text-align: center; font-weight: bold; margin-bottom:35px; font-size: 26px;">
      Accept Order
    </h2>

    <!-- Order Confirmation Number -->
    <div class="mb-6" style="display: flex; align-items: center;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;justify-content: space-between;">Order Confirmation Number:</label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <input matInput [(ngModel)]="orderConfirmationNumber"
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" readonly />
      </mat-form-field>
    </div>

    <!-- Estimated Delivery Date - Hidden for Service workflow -->
    <div *ngIf="false" class="mb-6" style="display: flex; align-items: center;justify-content: space-between;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;">Estimated Delivery Date: <span style="color: red;"> *</span></label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <input matInput [matDatepicker]="deliveryPicker" [(ngModel)]="deliveryDate" #deliveryCtrl="ngModel" required
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" />
        <mat-datepicker-toggle matSuffix [for]="deliveryPicker"></mat-datepicker-toggle>
        <mat-datepicker #deliveryPicker></mat-datepicker>
        <mat-error *ngIf="deliveryCtrl.invalid && deliveryCtrl.touched">
          Delivery date is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Estimated Shipping Date - Hidden for Service workflow -->
    <div *ngIf="false" class="mb-10" style="display: flex; align-items: center;justify-content: space-between;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;">Estimated Shipping Date: <span style="color: red;"> *</span></label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <input matInput [matDatepicker]="shippingPicker" [(ngModel)]="shippingDate" #shippingCtrl="ngModel" required
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" />
        <mat-datepicker-toggle matSuffix [for]="shippingPicker"></mat-datepicker-toggle>
        <mat-datepicker #shippingPicker></mat-datepicker>
        <mat-error *ngIf="shippingCtrl.invalid && shippingCtrl.touched">
          Shipping date is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
      <button (click)="cancel()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-right:8px; background:#e5e5e5;">
        Cancel
      </button>
      <button (click)="acceptOrder()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-left:8px; background-color: #1F7E35; color:#fff;">
        Accept Order
      </button>
    </div>
  </div>
</div>

<!-- Order Confirmed Modal -->
<div
  class="blur"
  *ngIf="showOrderConfirmed"
  (click)="cancel()"
></div>
<div class="namemodal" *ngIf="showOrderConfirmed" style="width: 25%; padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <h2 style="font-size:24px; font-weight:bold; margin-bottom:20px;">
      Order confirmed!
    </h2>

    <p style="font-size:15px; margin-bottom:15px;">
      Order: <strong>"{{this.orderConfirmationNumber}}"</strong> is confirmed!
    </p>

    <p style="margin-bottom:30px; font-size:15px;">
      Click
      <a href="javascript:void(0);"
        style="color:#007BFF; text-decoration:underline;"
        (click)="goToConfirmedOrderOverview()">
        here
      </a>
      for an overview of confirmed order.
    </p>
    <div style="text-align: center;">
      <button (click)="closeAcceptOrderConfirmation()"
        style="background-color:#1F7E35;color:#fff;font-size:16px;padding:8px 28px;border:none;border-radius:6px;cursor:pointer;">
        Done
      </button>
    </div>
  </div>
</div>

<!-- Reject Order Modal -->
<div
  class="blur"
  *ngIf="showRejectOrder"
  (click)="cancel()"
></div>

<div class="namemodal" *ngIf="showRejectOrder" style="width: 25%; padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <!-- Title -->
    <h2 style="text-align: center; font-weight: bold; margin-bottom:35px; font-size: 26px;">
      Reject Order
    </h2>

    <!-- Reason for rejection -->
    <div class="mb-6" style="display: flex; align-items: center;">
      <label style="min-width: 160px; font-weight: 500; font-size: 16px;">Reason for rejection:</label>
      <mat-form-field appearance="fill" class="flex-1" style="width: 100%;">
        <select matNativeControl [(ngModel)]="rejectionReason"
                class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none">
          <option value="">Please select</option>
          <option *ngFor="let item of rejectionReasons" [value]="item.id">
            {{ item.reason }}
          </option>
        </select>
      </mat-form-field>
    </div>

    <!-- Message for rejection -->
    <div class="mb-6">
      <label style="min-width: 200px; font-weight: 500; font-size: 16px; margin-top: 6px;margin-bottom: 10px;">
        Type the message for rejection here:
      </label>
      <mat-form-field appearance="fill" class="flex-1" style="width: 100%;">
        <textarea matInput [(ngModel)]="rejectionMessage"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" rows="4"></textarea>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;margin-bottom: 20px;">
      <button (click)="cancel()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-right:8px; background:#e5e5e5;">
        Cancel
      </button>
      <button (click)="rejectOrder()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-left:8px; background-color: #E40000; color:#fff;">
        Reject Order
      </button>
    </div>
  </div>
</div>



<div class="kyc-overlay" *ngIf="showKycAlert">
  <div class="kyc-shell" role="dialog" aria-modal="true">
    <!-- Header -->
    <header class="kyc-header">
      <div class="kyc-header__grain"></div>
      <div class="kyc-header__glow kyc-header__glow--a"></div>
      <div class="kyc-header__glow kyc-header__glow--b"></div>
      <div class="kyc-header__content">
        <span class="kyc-eyebrow">
          <mat-icon>verified_user</mat-icon>
          Verification Required
        </span>
        <h2>
          {{ copy.title }}
        </h2>
        <p>
          {{ copy.body }}
        </p>
      </div>
    </header>
    <!-- Body -->
    <section class="kyc-body">
      
      <ul class="kyc-steps" *ngIf="copy.showSteps">
        <li>
          <span class="kyc-step-icon">
            <mat-icon>edit_note</mat-icon>
          </span>
          <div>
            <strong>Business details</strong>
            <small>
              Fill organisation, banking & document details
            </small>
          </div>
        </li>
        <li>
          <span class="kyc-step-icon">
            <mat-icon>fact_check</mat-icon>
          </span>
          <div>
            <strong>Submit for review</strong>
            <small>
              Our team will verify your submitted information
            </small>
          </div>
        </li>
        <li>
          <span class="kyc-step-icon">
            <mat-icon>schedule</mat-icon>
          </span>
          <div>
            <strong>Approval process</strong>
            <small>
              Typically completed within 2–3 business days
            </small>
          </div>
        </li>
      </ul>

      <div class="prompt-meta" *ngIf="selectedReference">
        Reference: <strong>{{ selectedReference }}</strong>
      </div>

      <div class="kyc-notice">
        <mat-icon>info</mat-icon>
        <span>
          KYC approval is required before accepting or rejecting purchase orders.
        </span>
      </div>
    </section>

    <!-- Footer -->
    <footer class="kyc-footer">
      <button *ngIf="copy.ctaLabel && !kycLoader" mat-flat-button color="accent" class="cta-orange" (click)="proceed()">{{ copy.ctaLabel }}</button>

    </footer>


  </div>
</div>

<app-s-token-supplier-kyc
  *ngIf="showWizard && selectedKycId"
  [kycId]="selectedKycId"
  [supplierId]="supplierId"
  [kycReference]="selectedReference"
  [readOnly]="selectedReadOnly"
  [presetLookups]="lookups"
  (close)="closeWizard()"
  (saved)="onWizardSaved($event)"
></app-s-token-supplier-kyc> 